import {
  Combobox,
  makeStyles,
  Option,
  useId,
} from "@fluentui/react-components";
import type { ComboboxProps, OptionOnSelectData } from "@fluentui/react-components";
import type { EAppId} from "../../../../interfaces";
import { configurableApplication, AppIdsMap } from "../../../../interfaces";

const useStyles = makeStyles({
  root: {
    display: "grid",
    gridTemplateRows: "repeat(1fr)",
    justifyItems: "start",
    gap: "10px",
    maxWidth: "400px",
  }
});

export interface ISelectApplicationProps extends Partial<ComboboxProps> {
  selectedApplication: EAppId;
  onApplicationSelect(application: EAppId): void;
}

export const SelectApplication = (props: ISelectApplicationProps) => {
  const { selectedApplication, onApplicationSelect } = props;
  const comboId = useId("combo-default");

  const options = Object.entries(configurableApplication);
  const styles = useStyles();

  const onApplicationSelected = (data: OptionOnSelectData): void => {
    if (data.optionValue !== undefined) {
      onApplicationSelect(AppIdsMap[data.optionValue]);
    }
  };

  return (
    <div className={styles.root}>
      <label id={comboId}>Select the application to configure.</label>
      <Combobox
        selectedOptions={[configurableApplication[selectedApplication]]}
        value={configurableApplication[selectedApplication]}
        onOptionSelect={(_, data) => onApplicationSelected(data)}
        aria-labelledby={comboId}
        {...props}
      >
        {options.map(([key, value]) => (
          <Option key={key}>
            {value}
          </Option>
        ))}
      </Combobox>
    </div>
  );
};